var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('action-icon',{staticClass:"action-view-icon"},[_vm._t("default",[_vm._v("mdi-account")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }